import type { CloudGraphDocumentEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI: CloudGraphDocumentEntityAti[] = [
	'ati:cloud:graph:document',
];
